//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.BooleanOperation.js";
import "../no/DateTest.js";
import "../GeometricUtilities/GeometricUtilities.EnumTest.js";
import "../no/LineWidthTestBuilder.js";
import "../Features/Features.JoeListItemList.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/SelectObject.js";
import "../no/Section.js";
import "../no/ExpressionCollectorSetList.js";
import "../no/SelectObjectList.js";
import "../GeometricUtilities/GeometricUtilities.StringTestBuilder.js";
import "../GeometricUtilities/GeometricUtilities.ValueTestBuilder.js";
import "../no/GeometricUtilities.js";
import "../no/Expression.js";
import "../no/DateTest.js";
import "../no/LineWidthTestBuilder.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[1,"AngularDimension",0,"Expression",0],[1,"BooleanOperation",0,"GeometricUtilities.BooleanOperation",0],[1,"DateTest",0,"DateTest",0],[1,"Dimension",0,"Expression",0],[0,"DisableSelections",1,0],[0,"DiscreetType",1,0],[1,"DoubleLinearDimension",0,"Expression",0],[1,"EnumTest",0,"GeometricUtilities.EnumTest",0],[1,"Expression",0,"Expression",0],[0,"Integer",1,0],[1,"LineWidthTest",0,"LineWidthTestBuilder",0],[1,"List",0,"Features.JoeListItemList",0],[0,"Name",1,0],[1,"OnPathDim",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"Path",0,"SelectObject",0],[0,"Point",1,"Point",0],[1,"RadiusDimension",0,"Expression",0],[1,"Section",0,"Section",0],[1,"Seldimlist",0,"ExpressionCollectorSetList",0],[1,"Selection",0,"SelectObjectList",0],[1,"StringTest",0,"GeometricUtilities.StringTestBuilder",0],[0,"Toggle",1,0],[0,"Tolerance",1,0],[1,"TwoSidedAngular",0,"Expression",0],[1,"TwoSidedLinear",0,"Expression",0],[1,"ValueTest",0,"GeometricUtilities.ValueTestBuilder",0]],[[[],"ActionButton",{},0,0],[[],"DoSevereException",{},0,0],[["n_lines"],"GetLines",{R_:{lines:""}},0,0],[["lines"],"SetLines",{},1,0],[["n_lines"],"GetNonItiLines",{R_:{lines:""}},0,0],[["lines"],"SetNonItiLines",{},1,0],[["value","name","position"],"NewListItem",{R_:{listitem:"Features.JoeListItem"}},3,0]],[]];
SPLM.Features.JoeBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.JoeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.JoeBuilder.DiscreetTypes = Object.freeze({
    "Option1" : "Option1", "Option2" : "Option2"});

export default SPLM;